import React, { useState, useEffect, useContext } from 'react';
import { Card, Badge, NoticeBar } from 'antd-mobile';
import BasicContext from '../../BasicContext';

import { UrlSearch, renderCompanyCNameByCompanyId } from "../../../../utils/utils";
import Permission from '../../components/Permission';
import { AclKeys } from '../../utils/permissions';
import { Loading, Descriptions, Error } from '../../components';

import * as Api from "../../../../api/order";
import { GetCompanyList } from '../../../../api/usms';
import { TimeFormatType, WalletRechargeStatusBadge, WalletRechargeStatus } from '../../utils/const';
import { formatBillUnit } from '../../utils/common';
import WalletRechargeModal from './WalletRechargeModal';

import moment from 'moment';
import '../../index.css';

const errorUserIdMessage = '当前充值钱包未匹配到用户，请确认已配置用户钱包'
function WalletList () {

  const context = useContext(BasicContext);
  const customerList = context.customers;

  const [transactionId, setTransactionId] = useState("");
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({});
  const [companyLoading, setCompanyLoading] = useState(false);
  const [CompanyId, setCompanyId] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    initData();
  }, [])

  const initData = () => {
    const transactionId = UrlSearch("transactionId");
    setTransactionId(transactionId);
    if (transactionId) {
      getInfo(transactionId);
    }
  }

  const getInfo = (TransactionId) => {
    const data = {
      TransactionId: TransactionId,
    }
    setLoading(true);
    Api.GetWalletUserTransaction(data).then(res => {
      if (res && res.Data.length) {
        const info = res.Data[0] || {};
        setInfo(info);
        setCompanyId(info.UserId)
      }
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  useEffect(() => {
    if (CompanyId) {
      getCompanyInfo(CompanyId);
    }
  }, [CompanyId])

  const getCompanyInfo = (CompanyId) => {
    const data = {
      CompanyIds: [+CompanyId],
    }
    setCompanyLoading(true);
    GetCompanyList(data).then(res => {
      if (res.Data) {
        setCompanyInfo(res.Data[0] || {});
      } else {
        setErrorMessage("获取公司信息失败，项目ID：" + CompanyId)
      }
      setCompanyLoading(false);
    }).catch(e => {
      setCompanyLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  const CompanyInfoOptions = (companyInfo) => [
    { label: '账户可用金额', value: `${formatBillUnit(companyInfo.AmountAvailable)} ${(companyInfo.Currency || '').toUpperCase()}` },
    { label: '现金余额', value: `${formatBillUnit(companyInfo.Amount)} ${(companyInfo.Currency || '').toUpperCase()}` },
    { label: '赠金', value: `${formatBillUnit(companyInfo.AmountFree)} ${(companyInfo.Currency || '').toUpperCase()}` },
    { label: '信用额度', value: `${formatBillUnit(companyInfo.AmountCredit)} ${(companyInfo.Currency || '').toUpperCase()}` },
    { label: '冻结余额', value: `${formatBillUnit(companyInfo.AmountFreeze)} ${(companyInfo.Currency || '').toUpperCase()}` },
  ]

  const infoOptions = (info) => [
    { label: '交易ID', value: info.TransactionId },
    { label: '金额(USD)', value: formatBillUnit(info.Amount) || 0 },
    { label: '支出方钱包', value: info.FromAddress },
    { label: '收入方钱包', value: info.ToAddress },
    { label: '状态', value: <Badge text={WalletRechargeStatus[info.Status]} style={{ backgroundColor: WalletRechargeStatusBadge[info.Status] }} /> },
    { label: '交易结果', value: info.Result || '-' },
    { label: '代理商充值流水号', value: info.UserSerialNo || '-' },
    { label: '交易时间', value: moment(info.TranTime * 1000).format(TimeFormatType.date_xg) },
    { label: '充值说明', value: info.Message || '-' },
    { label: '公司ID', value: renderCompanyCNameByCompanyId(info.UserId, customerList) || 0 },
    { label: '创建时间', value: moment(info.CreateTime * 1000).format(TimeFormatType.date_xg) },
    { label: '更新时间', value: moment(info.UpdateTime * 1000).format(TimeFormatType.date_xg) },
  ]

  return (
    <div className="container">
      <h3 className='mb-10' style={{ overflowWrap: 'break-word' }}>钱包流水交易ID：{transactionId}</h3>
      <Loading loading={loading || companyLoading} error={errorMessage}>
        <div>
          <Card style={{ marginTop: '10px', }}>
            <Card.Header title="钱包充值流水信息" />
            <Card.Body style={{ overflowWrap: 'break-word' }}>
              <Descriptions options={infoOptions(info)} />
            </Card.Body>
          </Card>
          {info.UserId === 0 ?
            <div style={{ marginTop: '10px' }}>
              <Error style={{ marginTop: '10px' }} message={errorUserIdMessage} />
            </div> :
            <Card style={{ marginTop: '10px' }}>
              <Card.Header title="账户余额信息" />
              <Card.Body style={{ overflowWrap: 'break-word', }}>
                <Descriptions options={CompanyInfoOptions(companyInfo)} />
              </Card.Body>
            </Card>}
          <Permission aclKey={AclKeys.UserWalletRecharge}>
            {info.Status === 0 || info.Status === 5 ?
              <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <h3 style={{ marginBottom: '10px' }}>钱包信息确认：</h3>
                <WalletRechargeModal info={info} fetchBack={() => getInfo(transactionId)} />
              </div> :
              (<div style={{ margin: '10px 0' }}>
                <NoticeBar marqueeProps={{ loop: true }}>
                  {`当状态为待确认或者充值失败时，才能进行充值确认的操作`}
                </NoticeBar>
              </div>
              )}
          </Permission>
        </div>
      </Loading>
    </div>
  )
}

export default WalletList;